(function () {
  'use strict';
  var root = document.querySelector('[data-csd]');
  if (!root || !root.csdDesigner || !window.ErsProofSubmission) return;
  var designer = root.csdDesigner, canonical = window.ErsProofSubmission;
  var form = root.querySelector('.csd__order-form');
  var email = root.querySelector('[data-csd-order-email]');
  var attachment = root.querySelector('[data-csd-order-artwork]');
  var success = root.querySelector('[data-csd-order-success]');
  var data = JSON.parse(root.querySelector('[data-csd-order-data]').textContent);
  var sampleIds = { 'luxury-sushi': 'classic', 'modern-ramen': 'modern', cafe: 'simple', 'korean-bbq': 'bold', 'traditional-izakaya': 'traditional', 'text-only': 'text', instructional: 'instructional', locational: 'locational' };
  var types = { png: 'image/png', jpg: 'image/jpeg', jpeg: 'image/jpeg', webp: 'image/webp', svg: 'image/svg+xml', pdf: 'application/pdf', ai: 'application/illustrator', eps: 'application/postscript' };
  function sourceChoice() { return root.querySelector('[data-csd-artwork-source]:checked').getAttribute('data-csd-artwork-source'); }
  function attachmentProof(name) {
    var sides = {};
    ['front', 'back'].forEach(function (side) {
      var canvas = document.createElement('canvas'); canvas.width = 2100; canvas.height = 200;
      var context = canvas.getContext('2d'); context.fillStyle = '#ffffff'; context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = '#173f3a'; context.font = '32px Arial';
      context.fillText('Separate artwork supplied — review the attached source file.', 30, 75);
      context.fillText(name.slice(0, 90), 30, 130); sides[side] = canvas;
    });
    return sides;
  }
  // UI translation only: center-based Classic geometry -> Guided document
  // frames, literal text, design images, and professional template references.
  async function context() {
    var artwork = await designer.prepareProof(), raw = designer.getDesign(), assets = {}, colors = {}, hasImages = false;
    var document = { version: 3, id: 'classic-' + raw.productId, coordinateSpace: 'normalized',
      provenance: { kind: 'create-my-own', sourceId: sampleIds[raw.selectedSample] || raw.selectedSample || 'classic-custom', sourceVersion: 1 }, sides: {} };
    ['front', 'back'].forEach(function (side) {
      var state = raw.sides[side];
      if (state.background.toLowerCase() !== '#ffffff') colors[state.background.toLowerCase()] = true;
      document.sides[side] = { background: { fill: state.background }, objects: state.objects.map(function (item) {
        var height = item.type === 'text' ? item.fontSize * String(item.text).split('\n').length : item.height;
        var object = { id: item.id, type: item.type, role: item.role || '',
          frame: { x: item.x - item.width / 2, y: item.y - height / 2, width: item.width, height: height }, rotation: item.rotation || 0 };
        if (item.type === 'text') {
          colors[item.fill.toLowerCase()] = true;
          object.content = { kind: 'literal', value: item.text };
          object.style = { fontFamily: item.fontFamily, fontSize: item.fontSize, fontWeight: /bold/.test(item.fontStyle) ? 700 : 400,
            fontStyle: /italic/.test(item.fontStyle) ? 'italic' : 'normal', lineHeight: 1, letterSpacing: item.letterSpacing || 0,
            fill: item.fill, align: item.align || 'center', fit: 'fixed', wrap: 'none', paddingX: 0, paddingY: 0 };
        } else {
          hasImages = true;
          object.style = { fit: 'fill', align: 'center', padding: 0, opacity: 1 };
          if (item.dataUrl) {
            object.assetRef = { kind: 'design', assetId: item.id };
            assets[item.id] = { dataUrl: item.dataUrl, name: item.originalName || 'Logo' };
          } else {
            var sample = item.pdfSample && root.querySelector('[data-csd-sample="' + item.pdfSample + '"]');
            object.assetRef = { kind: 'template', templateId: item.id, sourceId: sampleIds[item.pdfSample] || item.pdfSample,
              url: item.assetUrl || (sample && sample.getAttribute('data-csd-vector-source')), crop: item.crop || null };
          }
        }
        return object;
      }) };
    });
    var source = sourceChoice(), attachments = [], original = attachment.files[0];
    if (source === 'different') {
      if (!original) throw new Error('Please choose the artwork file to send.');
      var type = types[original.name.split('.').pop().toLowerCase()];
      if (!type) throw new Error('Please choose a PDF, AI, EPS, SVG, PNG or JPG artwork file.');
      attachments.push({ name: original.name, blob: new Blob([original], { type: type }) });
      artwork = attachmentProof(original.name);
    }
    if (source === 'logo' && !Object.keys(assets).length) throw new Error('Please upload your logo before submitting.');
    var choice = root.querySelector('[name="contact[Chopstick type]"]:checked');
    var variant = data.variants.find(function (v) { return String(v.id) === choice.getAttribute('data-csd-variant-id'); });
    if (!variant) throw new Error('Please choose a chopstick type.');
    var quantity = Number(root.querySelector('[data-csd-quantity]').value);
    if (!Number.isInteger(quantity) || quantity < data.rules.minimumCases) throw new Error('Please enter at least 7 whole cases.');
    var printColors = hasImages ? 2 : Math.max(1, Math.min(2, Object.keys(colors).length));
    var setupFee = Number(printColors === 1 ? data.rules.oneColorSetupFee : data.rules.twoColorSetupFee);
    var order = { productId: data.product.id, productTitle: data.product.title, productUrl: data.product.url,
      variantId: variant.id, variantTitle: variant.title, variantDescriptor: variant.descriptor, sku: variant.sku || 'Not assigned',
      quantity: quantity, unitsPerCase: data.rules.unitsPerCase, totalUnits: quantity * data.rules.unitsPerCase,
      printColors: printColors, detectedPrintColors: printColors, merchandiseTotal: variant.price * quantity,
      setupFee: setupFee, estimatedTotal: variant.price * quantity + setupFee };
    var contact = { email: email.value, notes: root.querySelector('[data-csd-notes]').value, country: root.querySelector('[data-csd-country]').value,
      artworkSource: source, artworkSourceLabel: root.querySelector('[data-csd-artwork-source]:checked').value,
      colorCountNeedsReview: hasImages, proofRepresents: source === 'different' ? 'separate-attachment' : 'designer' };
    return { designDocument: document, assets: assets, attachments: attachments, artwork: artwork, order: order, contact: contact,
      recovery: { design: raw, contact: contact, order: order, attachment: source === 'different' ? original : null } };
  }
  function restore(saved) {
    designer.restoreAttempt(saved.design);
    email.value = saved.contact.email;
    root.querySelector('[data-csd-notes]').value = saved.contact.notes;
    root.querySelector('[data-csd-country]').value = saved.contact.country;
    root.querySelector('[data-csd-quantity]').value = saved.order.quantity;
    root.querySelector('[data-csd-variant-id="' + saved.order.variantId + '"]').checked = true;
    root.querySelector('[data-csd-artwork-source="' + saved.contact.artworkSource + '"]').checked = true;
    var original = saved.attachment;
    if (!original && saved.sourceFiles) {
      var previous = saved.sourceFiles.find(function (entry) { return entry.id === 'attachment'; });
      if (previous) original = previous.file;
    }
    if (original) { var transfer = new DataTransfer(); transfer.items.add(original); attachment.files = transfer.files; }
    root.querySelector('[data-csd-artwork-source]:checked').dispatchEvent(new Event('change', { bubbles: true }));
  }
  var flow = canonical.attach({ root: root, form: form, button: root.querySelector('[data-csd-submit]'), label: root.querySelector('[data-csd-submit-label]'),
    email: email, endpoint: root.getAttribute('data-proof-storage-endpoint'), cacheKey: 'ers:custom-chopstick-sleeve:product-proof', submitLabel: 'Submit Order',
    succeeded: Boolean(success), getContext: context, restore: restore, onReference: designer.setReference,
    fields: { reference: '[data-csd-design-reference]', storageSubmissionId: '[data-csd-storage-id]', artworkUrl: '[data-csd-artwork-url]',
      submissionUrl: '[data-csd-submission-url]', artworkFilename: '[data-csd-artwork-filename]', summary: '[data-csd-design-summary]' },
    onError: function (message) { var error = root.querySelector('[data-csd-order-error]'); error.textContent = message; error.classList.toggle('is-hidden', !message); if (message) error.focus(); },
    onSuccess: function (attempt) {
      if (!success) { success = document.createElement('p'); success.className = 'csd__notice csd__notice--success'; success.setAttribute('role', 'status'); form.prepend(success); }
      success.hidden = false; success.textContent = 'Thank you! Your artwork and request are saved. Reference: ' + attempt.reference + '. ';
      var link = document.createElement('a'); link.href = attempt.receipt.artworkUrl; link.textContent = 'Download submitted artwork'; success.append(link);
      root.querySelector('[data-csd-submit-label]').textContent = 'Request submitted';
    }
  });
  root.addEventListener('csd:design-change', function () { flow.edited(); if (success) success.hidden = true; });
  root.csdSubmission = flow;
}());
